import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'

import OfferCards from '../../components/login/offerCards'
import LoginModal from '../../components/common/loginModal';

import { loginURL } from '../../config'
import { openOauthSDKLogin } from '../../utils';

import BusLogo from '../../images/bus-logo.svg'
import BusBallon from '../../images/bus-ballon.jpg'
// import TopRightImage from '../../images/top-corner.jpg'
// import BottomLeftImage from '../../images/bottom-corner.jpg'

import { onLoginSuccess } from './actions'
import { routePrefix } from '../../config'
import './styles.css';
import EmailUpdatePopup from '../../components/EmailUpdatePopup'
import { fetchUser, submitEmail } from './utils'

const styles = {
  paraFirst: { color: '#002E6E' },
  paraSecond: { color: '#00B9F5' }
}

const url = loginURL;

class LoginContainer extends React.Component {

  state = {
    isLoginModalOpen: false,
    showUpdateEmailPopup: false,
    userEmail: '',
    isMerchant: false,
    shouldRedirect: false,
    emailType: '',
    dataLoaded: false
  }

  componentDidMount() {
    if (this.props.isLoggedIn) {
      this.fetchUserDetails();
    }
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.isLoggedIn && this.props.isLoggedIn) {
      this.fetchUserDetails();
    }
    if (prevProps.isLoginModalOpen !== this.state.isLoginModalOpen) {
      openOauthSDKLogin();
    }
  }

  fetchUserDetails = async () => {
    const data = await fetchUser();
    const { is_merchant = false, email = '', email_type = '' } = data || {};

    if (data && is_merchant) {
      this.setState({
        showUpdateEmailPopup: true,
        userEmail: email || "",
        isMerchant: true,
        emailType: email_type,
        dataLoaded: true
      });
    } else {      
      this.setState({
        showUpdateEmailPopup: false,
        shouldRedirect: true,
        dataLoaded: true
      });
    }
}

  submitUserEmail = async (newEmail) => {
    const data = await submitEmail(newEmail);
    const { v4RegisterResponse = {} } = data || {};    
    if (v4RegisterResponse && v4RegisterResponse.responseCode === "01") {
      setTimeout(() => {        
        this.setState({
          showUpdateEmailPopup: false,
          shouldRedirect: true,
        });
      }, 5000);
    }
    return data;
  } 

  openLoginModal = (value) => {
    this.setState({
      isLoginModalOpen: true
    })
  }

  closeLoginModal = () => {
    this.setState({
      isLoginModalOpen: false
    })
  }

  closeUpdateEmailPopup = () => {
    this.setState({ showUpdateEmailPopup: false });
  }

  render() {
    const { isLoginModalOpen, showUpdateEmailPopup, userEmail, isMerchant, shouldRedirect, emailType, dataLoaded } = this.state;

    if (dataLoaded && shouldRedirect) {      
      return <Redirect to={routePrefix + "/"} />
    }
    
    if (this.props.isLoggedIn) {      
      if (dataLoaded && isMerchant && showUpdateEmailPopup) {
        return (
          <EmailUpdatePopup 
            email={userEmail}
            emailType={emailType}
            onClose={() => {
              this.setState({ showUpdateEmailPopup: false, shouldRedirect: true });
              
            }}
            onSubmit={(newEmail) => this.submitUserEmail(newEmail)}
          />
        );
      }
      if (!dataLoaded) {
        return <div>Loading...</div>;
      }
            
      return <Redirect to={routePrefix + "/"} />
    }
    if(!isLoginModalOpen) {
      return (
        <div className="container productTabsContainer">
          {/*<img src={TopRightImage} alt="top-right-corner" />
          <img src={BottomLeftImage} alt="bottom-left-corner" />*/}
          <div className="row">
            <div className="col-xs-4 col-xs-offset-1" style={{ position: 'relative' }}>
              <img style={{ width: 200, height: 90 }} src={BusLogo} alt="bus-logo" />
              <div style={{ marginTop: 50 }}>
                <p className="loginText" style={styles.paraFirst}>India's <br />Fastest Growing</p>
                <p className="loginText" style={styles.paraSecond}>Bus Booking Platform</p>
              </div>
              <button className={`button button--default button--bold loginButton`} tabIndex='1' onClick={() => this.openLoginModal()}>
                Login
              </button>
            </div>
            <div className="col-xs-6 center-xs">
              <img src={BusBallon} alt="bus-ballon" />
            </div>
          </div>
          <div className="row col-xs-10 offerWrp">
            <OfferCards />
          </div>
        </div>
      )
    } else {
      return (
        <LoginModal closeLoginModal={this.closeLoginModal} />
      )
    }
  }
}

const mapStateToProps = store => ({
  isLoggedIn: store.userInfoReducer.isLoggedIn,
})

const mapDispatchToProps = dispatch => ({
  onLoginSuccess: () => dispatch(onLoginSuccess())
  // handleLogout: () => dispatch(actions.handleLogout()),
})

LoginContainer.propTypes = {
  isLoggedIn: PropTypes.bool.isRequired,
  // handleLogout: PropTypes.func.isRequired,
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginContainer)
